/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_Is_Default_TeamInputs */

const en_tables_custom_pages_is_default_team = /** @type {(inputs: Tables_Custom_Pages_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Is Default Team`)
};

const de_tables_custom_pages_is_default_team = /** @type {(inputs: Tables_Custom_Pages_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard Team`)
};

/**
* | output |
* | --- |
* | "Pages Is Default Team" |
*
* @param {Tables_Custom_Pages_Is_Default_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_is_default_team = /** @type {((inputs?: Tables_Custom_Pages_Is_Default_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_Is_Default_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_is_default_team(inputs)
	return de_tables_custom_pages_is_default_team(inputs)
});